import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "@/core/utils/date";
import {
  REFERRAL_FIELD,
  REFERRAL_FIELD_TO_SORTER,
} from "@/referrals/constants";
import { IReferral } from "@/referrals/referral";

const ReferredDateCol = (): ColumnDef<IReferral> => ({
  header: "Referred date",
  accessorFn: (row) => formatDate(row.created_at),
  sortingFn: (a, b) =>
    REFERRAL_FIELD_TO_SORTER[REFERRAL_FIELD.created_at](a.original, b.original),
});

export default ReferredDateCol;
